import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    productSarch: "",
    productClick: "",
    itemSearch: "",
    itemClick: "",
};

const inventorySlice = createSlice({
    name: "inventory",
    initialState,
    reducers: {
        setProductSarch: (state, action) => {
            state.productSarch = action.payload;
        },
        setItemSearch: (state, action) => {
            state.itemSearch = action.payload;
        },
        setItemClick: (state, action) => {
            state.itemClick = action.payload;
        },
        setProductClick: (state, action) => {
            state.productClick = action.payload;
        },
        resetProductSarch: (state) => {
            state.productSarch = initialState.productSarch;
        },
        resetItemSarch: (state) => {
            state.itemSearch = initialState.itemSearch;
        },
    }
});

export const {
    setProductSarch,
    setItemSearch,
    setItemClick,
    setProductClick,
    resetProductSarch,
    resetItemSarch,
} = inventorySlice.actions;
export default inventorySlice.reducer;